import React, {useState} from 'react';
import {  Box, Typography, Grid, Paper } from '@mui/material';
import products from './utils/ProductsMockData.json';
import main_images from './utils/MainImagesMockData.json';
import { theme } from './utils/theme';
import ReviewsSection from './ReviewSection';
import ProductCard from './ProductCard';
import ImageVideoCarousel from './ImageVideoCoursel';
import * as constants from './utils/constants'

function HomePage({ onSelectProduct }) {
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const manufacturingImages = ["Manufacturing1.png","Manufacturing2.png","Manufacturing3.png","Manufacturing4.png"]
    const milestones = [
    {
        key:'Units Sold',
        value: '35000+'
    },
    {
        key:'Retail Partners',
        value: '500+'
    },
    {
        key:'Customers Satisfaction',
        value: '99%'
    }]
    
    return (
        <>
            <Box sx={{ pt: 10, textAlign: 'center'}}>
            <ImageVideoCarousel products={main_images}/>
            {/* {
                main_images.map((main_image)=>{
                    return <CardMedia component="div">
                        <AnimatePresence initial={false}>
                            <motion.img
                                key={0}
                                src={require(process.env.PUBLIC_URL +main_image.images[currentImageIndex])}
                                alt={main_image.name}
                                initial={{ opacity: 0, x: 50 }}
                                animate={{ opacity: 1, x: 0 }}
                                exit={{ opacity: 1 }}
                                transition={{ duration: 0.5 }}
                                style={{width:'90%', height: '40vw'}}
                                onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x400/333/FFF?text=Image+Error'; }}
                            />
                        </AnimatePresence>
                    </CardMedia>
                    // <img  src={require(process.env.PUBLIC_URL +main_image.images[0])}></img>
                })
            } */}
            {/* <Box sx={{ pt: 4, pb: 4, textAlign: 'center' }}>
                <Container maxWidth="md">
                    <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
                        <Typography component="h1" variant="h2" gutterBottom sx={{
                            fontWeight: 'bold',
                            background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                        }}>
                            Eat Good Feel Good!
                        </Typography>
                        <Typography variant="h4" color="text.secondary" paragraph>
                            Fully Automatic Domestic Floor Mills Made In India
                        </Typography>
                    </motion.div>
                </Container>
            </Box> */}
            <Typography variant="h2" component="h2" sx={{  pt:10, textTransform:'uppercase', color: theme.palette.primary.dark }}>
              Our Products
            </Typography>
            <ProductCard products={products} onSelectProduct={onSelectProduct} />
            <Typography variant="h3" component="h2" sx={{  pt:15,fontWeight: 700, mb: 3, textTransform:'uppercase', color: theme.palette.primary.dark }}>
                Our Milestones
            </Typography>
            <Grid container spacing={{md:15,lg:20}} sx={{ px:10, display:'flex'}}>
                {milestones.map((milestone)=>(
                    <Grid item size={{xs:4}}>
                    <Paper elevation={2} flexDirection='column'sx={{ display:'flex', minHeight:'85px', flexDirection:'column', justifyContent:'space-between', background:'f2f2f2'}}>
                        <Typography variant="h4" color="text.secondary" sx={{fontWeight: 500}}>
                            {milestone.key}
                        </Typography>
                        <Typography variant="h5" color='text.secondary' sx={{fontWeight: 700}}>
                            {milestone.value}
                        </Typography>
                    </Paper>
                </Grid>
                ))}
            </Grid>
            <Typography variant="h3" component="h2" sx={{  pt:15,fontWeight: 700, mb: 3, textTransform:'uppercase', color: theme.palette.primary.dark }}>
              Uncompromising Quality in Every Product
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              At {constants.BRAND_NAME}, we are dedicated to excellence. Every product in our collection undergoes rigorous testing and quality assurance to ensure it meets the highest standards of performance, durability, and user satisfaction. We partner with leading manufacturers and utilize premium materials to deliver quality products you can trust. Invest in products that are built to last and designed to impress.
            </Typography>
            <Grid container spacing={2} sx={{ p:1, display:'flex', flexDirection:'row'}}>
                {manufacturingImages.map((manufacturingImage)=>(
                    <Grid item size={{md:6, lg:3}}>
                    <img
                    style={{
                        width: "100%",
                        height: "25vh",
                        objectFit: "fill",
                    }}
                    src={require(`${process.env.PUBLIC_URL}./utils/images/${manufacturingImage}`)}
                    />
                </Grid>
                ))}
                </Grid>
            <ReviewsSection />
            
            </Box>
        </>
    );
}

export default HomePage